// extracted by mini-css-extract-plugin
export var container = "_qp-0";
export var dotAnimation = "_qp-2";
export var dotsLoading = "_qp-1";